<template>
  <div class="p-4">
    <el-button class="float-right" type="primary" icon="el-icon-plus" circle size="small"
               @click="openNewStatusDialog()"></el-button>
    <el-table
      :data="statuses.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name"
        sortable>
      </el-table-column>
      <el-table-column
        prop="status"
        label="Status">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status"></el-switch>
        </template>
      </el-table-column>
      <el-table-column align="right" fixed="right">
        <template slot="header" slot-scope="scope">
          <el-input
            v-model="search"
            size="mini"
            placeholder="Type to search"/>
        </template>
        <template slot-scope="scope">
          <el-button @click="updateStatus(scope.$index, scope.row)" type="text" size="small">
            <i class="text-xl el-icon-edit-outline mr-4"></i>
          </el-button>
          <el-button @click="deleteStatus(scope.$index, scope.row.id)" type="text" size="small">
            <i class="text-xl text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <StatusUpdateForm />
    <NewStatusForm />
  </div>
</template>

<script>
import { flatMap } from 'lodash';
import StatusUpdateForm from './_includes/StatusUpdateForm.vue';
import NewStatusForm from './_includes/NewStatusForm.vue';

export default {
  name: 'Statuses',
  components: {
    StatusUpdateForm,
    NewStatusForm,
  },
  data() {
    return {
      search: '',
    };
  },
  computed: {
    statuses() {
      return flatMap(this.$store.state.SettingsModule.Statuses.statuses);
    },
  },
  methods: {
    openNewStatusDialog() {
      this.$modal.show('new-status-modal');
    },
    updateStatus(index, status) {
      this.$modal.show('update-status-modal');
      this.$store.commit('SettingsModule/Statuses/setProperty', { property: 'status', payload: status });
    },
    deleteStatus(index, statusId) {
      this.$confirm('Are you sure you want to delete this status?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('SettingsModule/Statuses/deleteStatus', { statusId });
          this.$notify.success({
            title: 'Success',
            message: 'Status has been deleted.',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
